import * as moment from 'moment/moment';

export const getTimezoneAbbr = (shortName: string): string => {
  if (!shortName) {
    return 'MST';
  }

  return shortName.split('(')[0];
};

/**
 * Maps a US timezone abbreviation (or a title like "CST(UTC -6)") to a single
 * IANA timezone identifier. The IANA zone is what lets moment-timezone resolve
 * the correct daylight/standard abbreviation and offset for a given date.
 *
 * Standard/daylight pairs collapse to one DST-observing region (e.g. CST/CDT →
 * America/Chicago) so the displayed label follows the record date automatically.
 * MST is intentionally mapped to America/Phoenix (no DST) so it always stays MST,
 * per the ticket reporter; MDT maps to America/Denver (observes DST).
 */
export const getIanaRegion = (shortName: string): string => {
  const abbr = getTimezoneAbbr(shortName);

  const regionByAbbr: Record<string, string> = {
    EST: 'America/New_York',
    EDT: 'America/New_York',
    CST: 'America/Chicago',
    CDT: 'America/Chicago',
    MST: 'America/Phoenix',
    MDT: 'America/Denver',
    PST: 'America/Los_Angeles',
    PDT: 'America/Los_Angeles',
    AKST: 'America/Anchorage',
    AKDT: 'America/Anchorage',
    HST: 'Pacific/Honolulu',
    HDT: 'Pacific/Honolulu',
    AST: 'America/Halifax',
  };

  return regionByAbbr[abbr] ?? 'America/Phoenix';
};

export const getTimeDifference = (time1: string, time2: string): string => {
  const date1 = moment(time1);
  const date2 = moment(time2);
  const difference = date2.diff(date1, 'minutes');
  const hours = Math.trunc(difference / 60);
  const minutes = difference % 60;

  return `${hours}:${minutes}`;
};
